import { render, staticRenderFns } from "./WatchedList.vue?vue&type=template&id=026b28d6&"
import script from "./WatchedList.vue?vue&type=script&lang=js&"
export * from "./WatchedList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports